export default __webpack_public_path__ + "static/peachLicense-c0fb08d0612763e980d354f999ad79fc.jpg";